import {
  UPDATE_CURRENT_PROVIDER_CONTENT,
  CURRENT_PROVIDER_CONTENT_OPEN,
  CURRENT_PROVIDER_CONTENT_CLOSE,
  CURRENT_PROCESS_INFO_OPEN,
  CURRENT_PROCESS_INFO_CLOSE
} from './types';

export const updateCurrentContent = content => ({
  type: UPDATE_CURRENT_PROVIDER_CONTENT,
  payload: content
});

export const openCurrentContent = () => ({
  type: CURRENT_PROVIDER_CONTENT_OPEN
});

export const openCurrentProcessInfo = () => ({
  type: CURRENT_PROCESS_INFO_OPEN
});

export const closeCurrentContent = () => ({
  type: CURRENT_PROVIDER_CONTENT_CLOSE
});

export const closeCurrentProcessInfo = () => ({
  type: CURRENT_PROCESS_INFO_CLOSE
});
